import React, { Fragment } from "react";
import { EmptyTableRow } from "./EmptyTableRow";
import { TableBody } from "./TableBody";
import { TableRow } from "./TableRow";
/**
 * Helper component that renders the body and all rows and cells using default rendering
 */
export const DefaultTableBody = ({ "data-testid": dataTestId = "body", emptyRowsMessage = "No data", noRowAlternateColors, rowOnClick, solidColorRowHover, subComponentRenderer, table, }) => {
    const { columnOrder } = table.getState();
    return (React.createElement(TableBody, { "data-testid": dataTestId },
        React.createElement(EmptyTableRow, { table: table }, emptyRowsMessage),
        table.getRowModel().rows.map((row, i) => (React.createElement(Fragment, { key: row.id },
            React.createElement(TableRow, { columnOrder: columnOrder, idx: i, noRowAlternateColors: noRowAlternateColors, onClick: rowOnClick, row: row, solidColorRowHover: solidColorRowHover }),
            subComponentRenderer && row.getIsExpanded() && subComponentRenderer(row))))));
};
